export * from './detail.component';
export * from './detail.service';
export * from './update-status.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/detail/index.ts